import {Component, inject} from '@angular/core';
import {ContainerComponent} from "@coreui/angular";
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {CausableLedgerComponent} from "./causable-ledger.component";

/**
 * Causable's receivable ledger: what an organization owes Causable in fees, and the remittances it
 * has paid. Global scope only — a game-scoped admin has no business seeing another organization's
 * position with Causable, and the API mirrors that with CausableAdminOnly on the whole controller.
 */
@Component({
  selector: 'app-causable-ledger-page',
  standalone: true,
  imports: [
    ContainerComponent,
    ChooseYourGameComponent,
    CausableLedgerComponent
  ],
  templateUrl: './causable-ledger-page.component.html',
})
export class CausableLedgerPageComponent {
  protected game: IGameQueryResult | null = null;

  onGameChosen(chosenGameP: IGameQueryResult) {
    this.game = chosenGameP;
  }
}
